<template>
  <LayoutSearchFieldVertical
    display-variant="list"
  >
    <div class="facet-buttons facet-mobile-grid">
      <button
        class="fb-button"
        v-for="(count, key) in counts"
        :class="{
          'is-0': count === 0,
          'is-selected': isSelected('+' + key),
        }"
        @click="select(key)"
        :key="key"
      >
        <span class="fb-label">{{ displayLabel(key) }}</span>
        <span class="fb-count" :title="num(count)">{{ num(count) }}</span>
      </button>
      <div class="no-facet" v-if="isEmpty(counts)">
        {{ lss('該当なし', 'No Hit') }}
      </div>
    </div>
  </LayoutSearchFieldVertical>
</template>
<script lang="ts" setup>
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { ls, lss, num } = useI18n()
const dataStore = useDataStore()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { facet, excludeDisplay } = useSearchFieldBase(props)

const count = (key: string) => {
  if (!facet.value) return undefined
  return facet.value.counts[key] || 0
}

const select = (key: string) => {
  key = '+' + key
  if (isSelected(key)) {
    props.ss.removeFilter(props.field.key, [key])
  } else {
    props.ss.addFilter(props.field.key, [key])
  }
}

const isSelected = (key: string) => {
  return props.ss.state.filter[props.field.key]?.includes(key)
}

const counts = computed(() => {
  if (!facet.value) return {}
  const keys = Object.keys(facet.value.counts).sort(
      (a, b) => facet.value.counts[b] - facet.value.counts[a]
  )
  let obj = {}
  keys.forEach((key) => {
    obj[key] = facet.value.counts[key]
  })
  return obj
})

const displayLabel = (key: string) => {
  const org = dataStore.organization(key)
  if (org && org.name) {
    const v = ls(org.name)
    if (v) return excludeDisplay(v, false, count(key))
  }
  return excludeDisplay(key, false, count(key))
}
</script>
